var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-3",attrs:{"color":`grey ${_vm.theme.isDark ? 'darken-2' : 'lighten-4'}`}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }